export const QUICK_PHRASES = [
  {
    category: "Identificación / Documentos",
    items: [
      { es: "Buenos días. Policía. ¿Tiene documentación, por favor?", ar: "صباح الخير. البوليس. عندك الوراق عافاك؟" },
      { es: "¿Cómo se llama?", ar: "شنو سميتك؟" },
      { es: "¿Cuál es su nacionalidad?", ar: "شنو هي جنسيتك؟" },
      { es: "¿Dónde vive?", ar: "فين ساكن؟" },
    ],
  },
  {
    category: "Instrucciones",
    items: [
      { es: "Tranquilo, no pasa nada.", ar: "هني راسك، ماكاين مشكل." },
      { es: "Espere aquí, por favor.", ar: "تسنى هنا عافاك." },
      { es: "Acompáñeme, por favor.", ar: "جي معايا عافاك." },
      { es: "Hable despacio, por favor.", ar: "هضر بشوية عافاك." },
    ],
  },
  {
    category: "Asistencia médica / Emergencias",
    items: [
      { es: "¿Necesita un médico?", ar: "محتاج طبيب؟" },
      { es: "¿Le duele algo?", ar: "كاين شي حاجة كتضرك؟" },
      { es: "La ambulancia está en camino.", ar: "الأمبولانس جاية فالطريق." },
      { es: "¿Toma alguna medicación?", ar: "كتاخد شي دوا؟" },
    ],
  },
  {
    category: "Preguntas de control",
    items: [
      { es: "¿Adónde va?", ar: "فين غادي؟" },
      { es: "¿Viene solo o con alguien?", ar: "جاي بوحدك ولا مع شي واحد؟" },
      { es: "¿Tiene el teléfono de algún familiar?", ar: "عندك تيليفون دشي واحد من العائلة؟" },
      { es: "¿Entiende lo que le digo?", ar: "فهمتي اش كنقول ليك؟" },
    ],
  },
];
